import React from 'react';
import ReactDOM from 'react-dom/client';
import GlobalStyle from './GlobalStyle';
import PublicApp from './PublicApp';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root') as HTMLElement;
const application = (
  <React.StrictMode>
    <GlobalStyle />
    <PublicApp />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, application);
} else {
  ReactDOM.createRoot(rootElement).render(application);
}

reportWebVitals();
